import { render, staticRenderFns } from "./resaleIntegrationDetailsModal.vue?vue&type=template&id=fd64a9fa&"
import script from "./resaleIntegrationDetailsModal.vue?vue&type=script&lang=js&"
export * from "./resaleIntegrationDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports